export default __webpack_public_path__ + "static/media/main-1.e2bad41c.jpg";